module.exports = __webpack_public_path__ + "img/R.09295259.svg";